import { withNamespace } from "@/i18n/lazy-route"

/** Messaging (LLD §9.6, Tasks 3.1, 3.2), with the `messaging` namespace. */
const translations = {
  en: () => import("@/i18n/locales/en/messaging.json"),
  fr: () => import("@/i18n/locales/fr/messaging.json"),
}

export const SendScreen = withNamespace(
  "messaging",
  () => import("./screens/SendScreen"),
  translations,
)
export const BulkSendScreen = withNamespace(
  "messaging",
  () => import("./screens/BulkSendScreen"),
  translations,
)
export const MessagesScreen = withNamespace(
  "messaging",
  () => import("./screens/MessagesScreen"),
  translations,
)
export const BatchScreen = withNamespace(
  "messaging",
  () => import("./screens/BatchScreen"),
  translations,
)
